import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./NursePreferences.css";
import Widgets from "../../../../widgets";
import ToastPopup from "../../../../widgets/Toast/toastPopup.js";

const NursePreferences = ({ setPage, setEnabledSteps, onSave, initialLanguage = "Vietnamese", initialGender = "Female" }) => {
  const { t } = useTranslation();

  const LANG_OPTIONS = [
    { value: "English", label: t("English") },
    { value: "Vietnamese", label: t("Vietnamese") },
  ];
  const GENDER_OPTIONS = [
    { value: "Male", label: t("Male") },
    { value: "Female", label: t("Female") },
  ];

  const [languagePref, setLanguagePref] = useState(initialLanguage);
  const [genderPref, setGenderPref] = useState(initialGender);

  const handleNext = () => {
    if (!languagePref || !genderPref) {
      ToastPopup.error(t("fillAllFields"));
      return;
    }
    onSave?.({ languagePreferences: [languagePref], genderPreferences: [genderPref] });
    setEnabledSteps?.((prev) => [...new Set([...prev, 4])]);
    setPage?.(4);
  };

  return (
    <div className="nurse-preferences-container">
      <div className="whp-container nurse-pref-card">
        <div className="title-hr2">
          <p>{t("nursePreferences")}</p>
          <hr />
        </div>

        <div className="nurse-pref-form">
          <div className="service-type-main2 nurse-pref-row">
            <div className="service-input-box form-section-col">
              <span>
                {t("preferredLanguage")} <label>*</label>
              </span>
              <Widgets.NewSelectDropdown
                options={LANG_OPTIONS}
                selectedValue={LANG_OPTIONS.find((o) => o.value === languagePref) || null}
                onChange={(opt) => setLanguagePref(opt?.value || "")}
                placeholder="selectLanguage"
                big
              />
            </div>

            <div className="service-input-box form-section-col">
              <span>
                {t("preferredGender")} <label>*</label>
              </span>
              <Widgets.NewSelectDropdown
                options={GENDER_OPTIONS}
                selectedValue={GENDER_OPTIONS.find((o) => o.value === genderPref) || null}
                onChange={(opt) => setGenderPref(opt?.value || "")}
                placeholder="selectGender"
                big
              />
            </div>
          </div>
        </div>
      </div>

      <div className="form-section-footer">
        <button className="form-section-cancel" onClick={() => setPage?.(2)}>
          {t("back")}
        </button>
        <button className="form-section-create" onClick={handleNext}>
          {t("generatequote")}
        </button>
      </div>
    </div>
  );
};

export default NursePreferences;
